const baseUrl = process.env.NODE_ENV === 'production' ? 'https://covidselfeval-api.azurewebsites.net' : 'https://covidselfeval-api-staging.azurewebsites.net'
// const baseUrl = 'https://covidselfeval-api-staging.azurewebsites.net' // ใช้เฉพาะ ลิ้ง develop 
const baseSubmitUrl = 'https://prod-31.southeastasia.logic.azure.com:443/workflows/4dc3bba911ba4d2ca06dbee441dcfcab/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=iULj8NicKXSJ1UEJBDHpDtdof1HqsdkU4Sq2XBFxgxE'
export {
    baseUrl,
    baseSubmitUrl
}